import { Portfolio } from "@crm/pages/portfolio";
import { createFileRoute } from "@tanstack/react-router";
import {
  clientDetailsQueryOptions,
  mfCentralStatusQueryOptions,
  portfolioSummaryV2QueryOptions,
} from "creso-core/hooks";
import {
  orderStatusSchema,
  productTypeSchema,
  submittedOrderTypeSchema,
} from "creso-core/zod";
import { object } from "zod";

function Layout() {
  return <Portfolio />;
}

export const Route = createFileRoute("/(auth)/_headed/clients/$id/portfolio")({
  component: Layout,
  validateSearch: object({
    order_status: orderStatusSchema.array().optional().catch([]),
    order_type: submittedOrderTypeSchema.array().optional().catch([]),
    product_type: productTypeSchema.array().optional().catch([]),
  }),
  loader: async ({ params, context }) => {
    const { queryClient } = context;
    try {
      const client = await queryClient.ensureQueryData(
        clientDetailsQueryOptions(Number(params.id))
      );
      if (!client?.investment_account) {
        return {
          client,
          portfolioSummary: null,
          mfCentralStatus: null,
        };
      }
      const [portfolioSummary, mfCentralStatus] = await Promise.allSettled([
        queryClient.ensureQueryData(
          portfolioSummaryV2QueryOptions(client?.investment_account ?? "")
        ),
        queryClient.ensureQueryData(
          mfCentralStatusQueryOptions(client?.investment_account ?? "")
        ),
      ]);
      return {
        client,
        portfolioSummary:
          portfolioSummary.status === "fulfilled"
            ? portfolioSummary.value
            : null,
        mfCentralStatus:
          mfCentralStatus.status === "fulfilled" ? mfCentralStatus.value : null,
      };
    } catch {
      return {};
    }
  },
});
